import {Injectable} from '@angular/core';
import {DataManagerService} from '../data/services/DataManager/data-manager.service';
import {AppConstants} from '../shared/constants/app-constants';

declare global {
  interface Window {
    zE?: any;
  }
}

@Injectable({providedIn: 'root'})
export class ZendeskMessagingService {
  private logged = false;
  private inProgress = false;

  constructor(private dataManager: DataManagerService) {
  }

  async login(): Promise<void> {
    if (this.logged || this.inProgress) {
      return;
    }
    this.inProgress = true;

    try {
      const jwt = await this.fetchJwt();
      if (!jwt) {
        return;
      }

      await this.waitForZendesk();

      if (typeof window.zE === 'function') {
        window.zE('messenger', 'loginUser', (cb: (token: string) => void) => cb(jwt));
      }
      this.logged = true;
    } catch {
      // no-op
    } finally {
      this.inProgress = false;
    }
  }

  logout(): void {
    try {
      if (typeof window.zE === 'function') {
        window.zE('messenger', 'logoutUser');
      }
    } catch {
    }
    this.logged = false;
    this.inProgress = false;
  }

  private fetchJwt(): Promise<string | null> {
    const url = AppConstants.BASE_URL + '/zendesk/sso-msg-token';

    return new Promise((resolve) => {
      this.dataManager.getRequest(url, 0).subscribe(
        (resp: any) => resolve(resp?.jwt ?? resp?.token ?? null),
        () => resolve(null)
      );
    });
  }

  private waitForZendesk(timeoutMs = 8000): Promise<void> {
    const started = Date.now();
    return new Promise((resolve, reject) => {
      const tick = () => {
        if (typeof (window as any).zE === 'function') {
          return resolve();
        }
        if (Date.now() - started > timeoutMs) {
          return reject(new Error('Zendesk not loaded'));
        }
        setTimeout(tick, 200);
      };
      tick();
    });
  }
}

// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { AppConstants } from '../shared/constants/app-constants';
//
// declare global {
//   interface Window {
//     zE?: any;
//   }
// }
//
// @Injectable({ providedIn: 'root' })
// export class ZendeskMessagingService {
//   private logged = false;
//   private inProgress = false;
//
//   constructor(private http: HttpClient) {}
//
//   async login(): Promise<void> {
//     if (this.logged || this.inProgress) return;
//     this.inProgress = true;
//
//     try {
//       const jwt = await this.fetchJwt();
//       if (!jwt) return;
//
//       await this.waitForZendesk();
//
//       window.zE('messenger', 'loginUser', (cb: (token: string) => void) => cb(jwt));
//       this.logged = true;
//     } catch {
//       // no-op
//     } finally {
//       this.inProgress = false;
//     }
//   }
//
//   logout(): void {
//     try {
//       if (typeof window.zE === 'function') {
//         window.zE('messenger', 'logoutUser');
//       }
//     } catch {
//       // no-op
//     }
//     this.logged = false;
//     this.inProgress = false;
//   }
//
//   private async fetchJwt(): Promise<string | null> {
//     try {
//       const url = AppConstants.BASE_URL + '/zendesk/sso-msg-token';
//       const resp = await this.http
//         .get<{ jwt?: string }>(url)
//         .toPromise();
//
//       return (resp && resp.jwt) ? resp.jwt : null;
//     } catch {
//       return null;
//     }
//   }
//
//   private async waitForZendesk(timeoutMs = 8000): Promise<void> {
//     const started = Date.now();
//
//     return new Promise((resolve, reject) => {
//       const tick = () => {
//         if (typeof window.zE === 'function') return resolve();
//         if (Date.now() - started > timeoutMs) return reject(new Error('Zendesk not loaded'));
//         setTimeout(tick, 200);
//       };
//       tick();
//     });
//   }
// }
